interface ParseScriptsProps {
  source?: string;
}

interface ScriptParams {
  [key: string]: string;
}

interface ScriptObject {
  params: ScriptParams;
  innerHTML?: string;
  tag: 'script' | 'link';
}

export const ParseScripts = ({ source }: ParseScriptsProps) => {
  if (!source) {
    return null;
  }

  const scriptRegex = /<script(?:\s+([^>]*))?>([\s\S]*?)<\/script>/gi;
  const linkRegex = /<link(?:\s+([^>]*))?\s*\/?>/gi;
  const paramRegex = /(\w+)=["']?([^"'\s]+)["']?/g;
  const scriptsAndLinks: ScriptObject[] = [];

  let match;
  while ((match = scriptRegex.exec(source)) !== null) {
    const paramStr = match[1] || '';
    const innerHTML = match[2];
    const params: ScriptParams = {};

    let paramMatch;
    while ((paramMatch = paramRegex.exec(paramStr)) !== null) {
      const [, key, value] = paramMatch;
      params[key] = value;
    }

    scriptsAndLinks.push({ params, innerHTML, tag: 'script' });
  }

  while ((match = linkRegex.exec(source)) !== null) {
    const paramStr = match[1] || '';
    const params: ScriptParams = {};

    let paramMatch;
    while ((paramMatch = paramRegex.exec(paramStr)) !== null) {
      const [, key, value] = paramMatch;
      params[key] = value;
    }

    scriptsAndLinks.push({ params, tag: 'link' });
  }

  return (
    <>
      {scriptsAndLinks.map((item, index) =>
        item.tag === 'script' ? (
          <script
            key={index}
            {...item.params}
            dangerouslySetInnerHTML={item.innerHTML != null ? { __html: item.innerHTML } : undefined}
          />
        ) : (
          <link key={index} {...item.params} />
        )
      )}
    </>
  );
};
